import { generateResponsiveTemplateSpacing } from '../Spacing/core';
import { generateResponsiveTemplate } from '../utils/styles-utils';
export const gapTemplate = value => {
  return generateResponsiveTemplateSpacing(value, 'gap');
};
export const columnGapTemplate = value => {
  return generateResponsiveTemplateSpacing(value, 'column-gap');
};
export const rowGapTemplate = value => {
  return generateResponsiveTemplateSpacing(value, 'row-gap');
};
export const flexDirectionTemplate = value => {
  return generateResponsiveTemplate(value, 'flex-direction');
};
export const flexWrapTemplate = value => {
  return generateResponsiveTemplate(value, 'flex-wrap');
};
export const justifyContentTemplate = value => {
  return generateResponsiveTemplate(value, 'justify-content');
};
export const alignItemsTemplate = value => {
  return generateResponsiveTemplate(value, 'align-items');
};
export const flexGrowTemplate = value => {
  return generateResponsiveTemplate(value, 'flex-grow');
};

/**
 * pre-defined values for flex css properties to help with intellisense when consuming Flex component
 */

export const JustifyContent = {
  'flex-start': 'flex-start',
  'flex-end': 'flex-end',
  center: 'center',
  'space-between': 'space-between',
  'space-around': 'space-around',
  'space-evenly': 'space-evenly'
};
export const AlignItems = {
  'flex-start': 'flex-start',
  'flex-end': 'flex-end',
  baseline: 'baseline',
  center: 'center',
  stretch: 'stretch'
};
export const Wrap = {
  wrap: 'wrap',
  nowrap: 'nowrap'
};
export const Direction = {
  row: 'row',
  column: 'column',
  'row-reverse': 'row-reverse',
  'column-reverse': 'column-reverse'
};

/**
 * Pre-defined sizes for justify-content property
 * @typedef {keyof JustifyContent} JustifyContentValues
 */

/**
 * Pre-defined sizes for align-items property
 * @typedef {keyof AlignItems} AlignItemsValues
 */

/**
 * Pre-defined sizes for flex-wrap property
 * @typedef {keyof Wrap} WrapValues
 */

/**
 * Pre-defined sizes for flex-direction property
 * @typedef {keyof Direction} DirectionValues
 */

/**
 * Pre-defined sizes for flex-direction property
 * @typedef {import('react').CSSProperties['flexGrow']} Grow
 */
//# sourceMappingURL=core.js.map